const common = {
    roleType: {
        ordinaryRole: 0, //普通角色
        orgRole: 1, //组织角色
        doorAuthGroup: 2 //门禁权限组
    },
    //登录程序
    loginProcess: {
        allLoginProcess: 0,
        onlyLoginProcess: 1
    },
    //登录程序启用
    loginProcess_enable: {
        no: 0,
        yes: 1
    },
    defaultSysFlag: 'PG'
};
export default common;
